import { KYMW1409Model } from '../kymw1409.model';
import { RegistUseMarkModel } from '../../kymw1400/vo/regist-use-mark.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 使用マークを登録する。
 *
 * @export
 * @class RegistUseMarkService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class RegistUseMarkService extends PlessJsonResponderSub<any> {

  private model: KYMW1409Model = null;
  private vo: RegistUseMarkModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistUseMarkService
   */
  private getBody(): PlessRequest {
    const combinations = this.vo.pCode.map(pCode => {
      const ogfi = (this.vo.orderGoodsFlgKoma as Array<any>).find(ogfi => ogfi.PCode == pCode);
      return {
        condition: {
          PCode: pCode,
          ReceiptSOrderCode: ogfi.ReceiptSOrderCode,
          OrderNum6Digits: ogfi.OrderNum6Digits,
          ItemCode: ogfi.ItemCode,
          OrderGoodsFlg: ogfi.OrderGoodsFlg,
        }
      };
    });

    return new PlessRequest({
      regist: {
        Mark: {
          condition: {
                OrderCode: this.vo.orderCode,
                CoopCode: this.vo.coopCode,
                MarkCode: this.vo.markCode,
            OrderGoodsFlg: this.vo.orderGoodsFlg
          },
          combination: combinations
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1409Model} model
   * @param {RegistUseMarkModel} vo
   * @memberof RegistUseMarkService
   */
  execute(model: KYMW1409Model, vo: RegistUseMarkModel) {
    this.model = model;
    this.vo = vo;
    this.send('registUseMark', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistUseMarkService
   */
  success(data: any) {
    // 使用マークチェックボックス設定処理
    this.model.setMark();
  }
}
